import React from 'react';

interface IJsonProps {
    json: unknown;
}

export const Json = ({ json }: IJsonProps) => {
    return <pre>{JSON.stringify(json, undefined, 2)}</pre>;
};
